import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GerenciadorRoutingModule } from './gerenciador-routing.module';
import { FooterComponent } from './footer/footer.component';
import { SidenavbarComponent } from './sidenavbar/sidenavbar.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { EventosComponent } from './dashboard/eventos/eventos.component';
import { InicioComponent } from './dashboard/inicio/inicio.component';
import { FileUploadModule } from 'ng2-file-upload/ng2-file-upload';
import { GaleriaFormComponent } from './dashboard/galeria-form/galeria-form.component';
import { NavComponent } from './nav/nav.component';
import { EventosService } from './dashboard/eventos/eventos.service';
import { UsuarioService } from './dashboard/usuario/usuario.service';
import { UsuarioComponent } from './dashboard/usuario/usuario.component';
import { AlterarSenhaComponent } from './dashboard/alterar-senha/alterar-senha.component';
import { AlterarSenhaService } from './dashboard/alterar-senha/alterar-senha.service';

@NgModule({
  imports: [
    CommonModule,
    GerenciadorRoutingModule,
    FormsModule,
    HttpModule,
    FileUploadModule
  ],
  declarations: [
    FooterComponent,
    SidenavbarComponent,
    DashboardComponent,
    EventosComponent,
    InicioComponent,
    GaleriaFormComponent,
    AlterarSenhaComponent,
    NavComponent,
    UsuarioComponent,

  ],
  exports: [
    FooterComponent,
    SidenavbarComponent,
    DashboardComponent,
    InicioComponent,
    EventosComponent,
    GaleriaFormComponent,
    AlterarSenhaComponent,
    NavComponent,
    UsuarioComponent
  ],
  providers: [EventosService, UsuarioService, AlterarSenhaService],
  bootstrap: []
})
export class GerenciadorModule { }



// WEBPACK FOOTER //
// ./src/app/gerenciador/gerenciador.module.ts